__turbopack_context__.v({
  "academyArticle": "MobileMenu-module-scss-module__lqaK6G__academyArticle",
  "academyBackToHome": "MobileMenu-module-scss-module__lqaK6G__academyBackToHome",
  "academyBackToHomeIcon": "MobileMenu-module-scss-module__lqaK6G__academyBackToHomeIcon",
  "academyBackToHomeLabel": "MobileMenu-module-scss-module__lqaK6G__academyBackToHomeLabel",
  "academyCategory": "MobileMenu-module-scss-module__lqaK6G__academyCategory",
  "academyCategoryChevron": "MobileMenu-module-scss-module__lqaK6G__academyCategoryChevron",
  "academyCategoryContent": "MobileMenu-module-scss-module__lqaK6G__academyCategoryContent",
  "academyCategoryHeader": "MobileMenu-module-scss-module__lqaK6G__academyCategoryHeader",
  "academyCategoryTitle": "MobileMenu-module-scss-module__lqaK6G__academyCategoryTitle",
  "academyDocumentationChildren": "MobileMenu-module-scss-module__lqaK6G__academyDocumentationChildren",
  "academyDocumentationSection": "MobileMenu-module-scss-module__lqaK6G__academyDocumentationSection",
  "academyMainNavChevron": "MobileMenu-module-scss-module__lqaK6G__academyMainNavChevron",
  "academyMainNavIcon": "MobileMenu-module-scss-module__lqaK6G__academyMainNavIcon",
  "academyMainNavItem": "MobileMenu-module-scss-module__lqaK6G__academyMainNavItem",
  "academyMainNavLabel": "MobileMenu-module-scss-module__lqaK6G__academyMainNavLabel",
  "academyMainNavigation": "MobileMenu-module-scss-module__lqaK6G__academyMainNavigation",
  "academyQuickStartList": "MobileMenu-module-scss-module__lqaK6G__academyQuickStartList",
  "academyQuickStartProgress": "MobileMenu-module-scss-module__lqaK6G__academyQuickStartProgress",
  "academyQuickStartProgressBar": "MobileMenu-module-scss-module__lqaK6G__academyQuickStartProgressBar",
  "academyQuickStartProgressBarFill": "MobileMenu-module-scss-module__lqaK6G__academyQuickStartProgressBarFill",
  "academyQuickStartProgressHeader": "MobileMenu-module-scss-module__lqaK6G__academyQuickStartProgressHeader",
  "academyQuickStartProgressLabel": "MobileMenu-module-scss-module__lqaK6G__academyQuickStartProgressLabel",
  "academyQuickStartProgressPercentage": "MobileMenu-module-scss-module__lqaK6G__academyQuickStartProgressPercentage",
  "academyQuickStartProgressText": "MobileMenu-module-scss-module__lqaK6G__academyQuickStartProgressText",
  "academySectionChildren": "MobileMenu-module-scss-module__lqaK6G__academySectionChildren",
  "academySectionGroup": "MobileMenu-module-scss-module__lqaK6G__academySectionGroup",
  "academySectionHeader": "MobileMenu-module-scss-module__lqaK6G__academySectionHeader",
  "academySectionHeaderLabel": "MobileMenu-module-scss-module__lqaK6G__academySectionHeaderLabel",
  "accountDrawer": "MobileMenu-module-scss-module__lqaK6G__accountDrawer",
  "accountDrawerContent": "MobileMenu-module-scss-module__lqaK6G__accountDrawerContent",
  "accountDrawerEmail": "MobileMenu-module-scss-module__lqaK6G__accountDrawerEmail",
  "accountDrawerHeader": "MobileMenu-module-scss-module__lqaK6G__accountDrawerHeader",
  "accountDrawerItem": "MobileMenu-module-scss-module__lqaK6G__accountDrawerItem",
  "accountDrawerItemIcon": "MobileMenu-module-scss-module__lqaK6G__accountDrawerItemIcon",
  "accountDrawerItemLabel": "MobileMenu-module-scss-module__lqaK6G__accountDrawerItemLabel",
  "accountDrawerName": "MobileMenu-module-scss-module__lqaK6G__accountDrawerName",
  "accountDrawerSeparator": "MobileMenu-module-scss-module__lqaK6G__accountDrawerSeparator",
  "accountDrawerTitleSection": "MobileMenu-module-scss-module__lqaK6G__accountDrawerTitleSection",
  "accountDrawerTitleText": "MobileMenu-module-scss-module__lqaK6G__accountDrawerTitleText",
  "accountItem": "MobileMenu-module-scss-module__lqaK6G__accountItem",
  "accountItemContent": "MobileMenu-module-scss-module__lqaK6G__accountItemContent",
  "accountItemEmail": "MobileMenu-module-scss-module__lqaK6G__accountItemEmail",
  "accountItemName": "MobileMenu-module-scss-module__lqaK6G__accountItemName",
  "accountItemText": "MobileMenu-module-scss-module__lqaK6G__accountItemText",
  "accountSection": "MobileMenu-module-scss-module__lqaK6G__accountSection",
  "active": "MobileMenu-module-scss-module__lqaK6G__active",
  "addNewButton": "MobileMenu-module-scss-module__lqaK6G__addNewButton",
  "addNewDrawer": "MobileMenu-module-scss-module__lqaK6G__addNewDrawer",
  "addNewDrawerContent": "MobileMenu-module-scss-module__lqaK6G__addNewDrawerContent",
  "addNewDrawerItem": "MobileMenu-module-scss-module__lqaK6G__addNewDrawerItem",
  "addNewDrawerItemIcon": "MobileMenu-module-scss-module__lqaK6G__addNewDrawerItemIcon",
  "addNewDrawerItemLabel": "MobileMenu-module-scss-module__lqaK6G__addNewDrawerItemLabel",
  "allLinksContainer": "MobileMenu-module-scss-module__lqaK6G__allLinksContainer",
  "appHeader": "MobileMenu-module-scss-module__lqaK6G__appHeader",
  "appHeaderContent": "MobileMenu-module-scss-module__lqaK6G__appHeaderContent",
  "appHeaderIcon": "MobileMenu-module-scss-module__lqaK6G__appHeaderIcon",
  "appHeaderLabel": "MobileMenu-module-scss-module__lqaK6G__appHeaderLabel",
  "appPickerCheckmark": "MobileMenu-module-scss-module__lqaK6G__appPickerCheckmark",
  "appPickerContent": "MobileMenu-module-scss-module__lqaK6G__appPickerContent",
  "appPickerDivider": "MobileMenu-module-scss-module__lqaK6G__appPickerDivider",
  "appPickerDragHandle": "MobileMenu-module-scss-module__lqaK6G__appPickerDragHandle",
  "appPickerDrawer": "MobileMenu-module-scss-module__lqaK6G__appPickerDrawer",
  "appPickerHeader": "MobileMenu-module-scss-module__lqaK6G__appPickerHeader",
  "appPickerItem": "MobileMenu-module-scss-module__lqaK6G__appPickerItem",
  "appPickerItemIcon": "MobileMenu-module-scss-module__lqaK6G__appPickerItemIcon",
  "appPickerItemLabel": "MobileMenu-module-scss-module__lqaK6G__appPickerItemLabel",
  "appPickerOverlay": "MobileMenu-module-scss-module__lqaK6G__appPickerOverlay",
  "appPickerTitle": "MobileMenu-module-scss-module__lqaK6G__appPickerTitle",
  "backButton": "MobileMenu-module-scss-module__lqaK6G__backButton",
  "checkmark": "MobileMenu-module-scss-module__lqaK6G__checkmark",
  "content": "MobileMenu-module-scss-module__lqaK6G__content",
  "disabled": "MobileMenu-module-scss-module__lqaK6G__disabled",
  "drawer": "MobileMenu-module-scss-module__lqaK6G__drawer",
  "emptyMessage": "MobileMenu-module-scss-module__lqaK6G__emptyMessage",
  "expanded": "MobileMenu-module-scss-module__lqaK6G__expanded",
  "expandedItem": "MobileMenu-module-scss-module__lqaK6G__expandedItem",
  "expandedItemLabel": "MobileMenu-module-scss-module__lqaK6G__expandedItemLabel",
  "expandedList": "MobileMenu-module-scss-module__lqaK6G__expandedList",
  "fadeIn": "MobileMenu-module-scss-module__lqaK6G__fadeIn",
  "feedback": "MobileMenu-module-scss-module__lqaK6G__feedback",
  "footer": "MobileMenu-module-scss-module__lqaK6G__footer",
  "hasActive": "MobileMenu-module-scss-module__lqaK6G__hasActive",
  "hasChildren": "MobileMenu-module-scss-module__lqaK6G__hasChildren",
  "header": "MobileMenu-module-scss-module__lqaK6G__header",
  "headerActions": "MobileMenu-module-scss-module__lqaK6G__headerActions",
  "headerLogo": "MobileMenu-module-scss-module__lqaK6G__headerLogo",
  "headerScrolled": "MobileMenu-module-scss-module__lqaK6G__headerScrolled",
  "loading": "MobileMenu-module-scss-module__lqaK6G__loading",
  "menuView": "MobileMenu-module-scss-module__lqaK6G__menuView",
  "modulesDrawer": "MobileMenu-module-scss-module__lqaK6G__modulesDrawer",
  "navGroup": "MobileMenu-module-scss-module__lqaK6G__navGroup",
  "navGroupLabel": "MobileMenu-module-scss-module__lqaK6G__navGroupLabel",
  "navItem": "MobileMenu-module-scss-module__lqaK6G__navItem",
  "navItemBadge": "MobileMenu-module-scss-module__lqaK6G__navItemBadge",
  "navItemIcon": "MobileMenu-module-scss-module__lqaK6G__navItemIcon",
  "navItemLabel": "MobileMenu-module-scss-module__lqaK6G__navItemLabel",
  "navItems": "MobileMenu-module-scss-module__lqaK6G__navItems",
  "navigationSection": "MobileMenu-module-scss-module__lqaK6G__navigationSection",
  "notificationBadge": "MobileMenu-module-scss-module__lqaK6G__notificationBadge",
  "notificationBtn": "MobileMenu-module-scss-module__lqaK6G__notificationBtn",
  "open": "MobileMenu-module-scss-module__lqaK6G__open",
  "overlay": "MobileMenu-module-scss-module__lqaK6G__overlay",
  "pickerEmptyMessage": "MobileMenu-module-scss-module__lqaK6G__pickerEmptyMessage",
  "pickerSectionLabel": "MobileMenu-module-scss-module__lqaK6G__pickerSectionLabel",
  "projectName": "MobileMenu-module-scss-module__lqaK6G__projectName",
  "search": "MobileMenu-module-scss-module__lqaK6G__search",
  "selected": "MobileMenu-module-scss-module__lqaK6G__selected",
  "slideDown": "MobileMenu-module-scss-module__lqaK6G__slideDown",
  "slideUp": "MobileMenu-module-scss-module__lqaK6G__slideUp",
  "spin": "MobileMenu-module-scss-module__lqaK6G__spin",
  "spinning": "MobileMenu-module-scss-module__lqaK6G__spinning",
  "submenuGroup": "MobileMenu-module-scss-module__lqaK6G__submenuGroup",
  "submenuGroupLabel": "MobileMenu-module-scss-module__lqaK6G__submenuGroupLabel",
  "submenuItem": "MobileMenu-module-scss-module__lqaK6G__submenuItem",
  "submenuItemIcon": "MobileMenu-module-scss-module__lqaK6G__submenuItemIcon",
  "submenuSection": "MobileMenu-module-scss-module__lqaK6G__submenuSection",
  "submenuSeparator": "MobileMenu-module-scss-module__lqaK6G__submenuSeparator",
  "viewMain": "MobileMenu-module-scss-module__lqaK6G__viewMain",
  "viewProjects": "MobileMenu-module-scss-module__lqaK6G__viewProjects",
  "viewWorkspaces": "MobileMenu-module-scss-module__lqaK6G__viewWorkspaces",
  "viewsContainer": "MobileMenu-module-scss-module__lqaK6G__viewsContainer",
  "visionTree": "MobileMenu-module-scss-module__lqaK6G__visionTree",
  "visionTreeContainer": "MobileMenu-module-scss-module__lqaK6G__visionTreeContainer",
  "visionTreeNoResults": "MobileMenu-module-scss-module__lqaK6G__visionTreeNoResults",
  "visionTreeNoResultsIcon": "MobileMenu-module-scss-module__lqaK6G__visionTreeNoResultsIcon",
  "visionTreeNoResultsMessage": "MobileMenu-module-scss-module__lqaK6G__visionTreeNoResultsMessage",
  "visionTreeNoResultsTitle": "MobileMenu-module-scss-module__lqaK6G__visionTreeNoResultsTitle",
  "visionTreeSearch": "MobileMenu-module-scss-module__lqaK6G__visionTreeSearch",
  "workspaceSelector": "MobileMenu-module-scss-module__lqaK6G__workspaceSelector",
  "workspaceSelectorLabel": "MobileMenu-module-scss-module__lqaK6G__workspaceSelectorLabel",
  "workspaceSelectorName": "MobileMenu-module-scss-module__lqaK6G__workspaceSelectorName",
  "workspaceSelectorText": "MobileMenu-module-scss-module__lqaK6G__workspaceSelectorText",
});
